import { parseCookie } from './cookies';

export const isClient = () => {
  return typeof window !== 'undefined';
};

export const isServer = () => {
  return !isClient();
};

export const isAuthenticated = () => {
  if (!isClient()) {
    return false;
  }
  const cookies = parseCookie(document.cookie);
  const authCookie = cookies?.['is_auth'];
  return authCookie === 'true' || authCookie === 'True';
};

export const isEnterpriseAuthenticated = () => {
  if (!isClient()) {
    return false;
  }
  const cookies = parseCookie(document.cookie);
  if (!cookies) return false;
  return Object.entries(cookies).some(
    ([key, value]) =>
      key.startsWith('auth0') &&
      key.endsWith('.is.authenticated') &&
      value.toLowerCase() === 'true',
  );
};
